export const environment = {
  apiUrl: 'https://admin.dev.pizza-milano-91.fr/api',
  appUrl :'https://admin.dev.pizza-milano-91.fr/'

}
